import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import Pagination from "react-js-pagination";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import './../../bootstrap/css/daterangepicker.css';
class LeaveRequests extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
            search: '',
            fromdate: '',
            todate: '',
            loading: 1,
            fields: {},
            item_count: '',
            isLoadMore: 1,
            activePage: 1,
            loading: 1,
            fields: {},
            errors: {},
            leave_detail: []
        };
        this.searchChange = this.searchChange.bind(this);
        this.formdateChange = this.formdateChange.bind(this);
        this.todateChange = this.todateChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    onChange(event) {
        let fields = this.state.fields;
        this.setState({ [event.target.name]: event.target.value });
        fields[event.target.name] = event.target.value;
    }

    formdateChange(event) {
        this.setState({ fromdate: event, from_date: moment(event).format("YYYY-MM-DD"), activePage: 1 }, function () {
            this.leaveList();
        });
    }

    todateChange(event) {
        this.setState({ todate: event, to_date: moment(event).format("YYYY-MM-DD"), activePage: 1 }, function () {
            this.leaveList();
        });
    }

    searchChange(event) {
        this.setState({ search: event.target.value, activePage: 1 }, function () {
            this.leaveList();
        });
    }

    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count > 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });

        fetch(this.state.apiUrl + '/HrmanagementRest/LeaveApplication/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey + '/page/' + pageNumber, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.leaves.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                }
                else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    leaves: this.state.leaves.concat(findresponse.leaves),
                })
            })
    }

    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/HrmanagementRest/LeaveApplication/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        leaves: findresponse.leaves,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }

    leaveList(page = 1) {
        fetch(this.state.apiUrl + '/HrmanagementRest/LeaveApplication/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    leaves: findresponse.leaves,
                    loading: 0,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes',
                    hr_permission: findresponse.hr_permission
                })
            })
    }

    leave_detail(id) {
        fetch(this.state.apiUrl + '/HrmanagementRest/LeaveDetails/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    leave_detail: findresponse.leave_detail,
                })
                this.setState({ startDate: moment(Date.parse(this.state.leave_detail.date)) })
                this.setState({ endDate: moment(Date.parse(this.state.leave_detail.to_date)) })
            })
    }

    approve_leave(id) {
        document.getElementById("add_approve").innerHTML = "Sending....";
        document.getElementById("add_approve").disabled = true;
        const fd = new FormData;
        fd.append('inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/HrmanagementRest/approveLeave/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                window.location.href = '/leaveRequests';
            })
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        if (!fields["decline_note"]) {
            formIsValid = false;
            errors["decline_note"] = "This field is required.";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    decline_leave(id) {
        document.getElementById("add_decline").innerHTML = "Sending....";
        document.getElementById("add_decline").disabled = true;
        // if (this.handleValidation()) {
        //     console.log("Data Has been submitted");
        // } else {
        //     console.log("This Fields Are required.")
        //     return false;
        // }
        const fd = new FormData;
        fd.append('inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/HrmanagementRest/declineLeave/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                window.location.href = '/leaveRequests';
            })
    }

    // ER#63788 Leave Application>>delete leave
    deleteLeaveRequest(id) {
        if (window.confirm('Are you sure! You want to delete the leave request?')) {
            fetch(this.state.apiUrl + '/HrmanagementRest/DeleteLeaveRequest/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    window.location.href = '/leaveRequests';
                })
        }
    }

    getUserRows() {
        if (this.state.loading) {
            return <div class="loader-new"></div>;
        } else {
            return (
                <div class="body-content">
                    <div class="employee-list table-wrap">
                        <table>
                            <thead>
                                <th class="intra_col_20">Name</th>
                                <th class="intra_col_20">Leave Duration</th>
                                <th class="intra_col_15">Reason</th>
                                <th class="intra_col_10">Applied</th>
                                <th class="intra_col_10">
                                    Available
                                    <br />
                                    (Quarterly)
                                </th>
                                <th class="intra_col_10">Status</th>
                                <th class="intra_col_10">Actions</th>
                                <th class="intra_col_5">Delete</th>
                            </thead>
                            <tbody>
                                {this.state.leaves.map((leaves, key) => (
                                    <tr>
                                        <td class="intra_col_20">
                                            <Link
                                                key={key}
                                                to={`/viewLeaveReward/${leaves.employee_id}`}
                                                name={"max"}
                                            >
                                                {leaves.name ? leaves.name : "--"}
                                            </Link>
                                        </td>
                                        <td class="intra_col_20">
                                            {leaves.date + " - " + leaves.to_date}
                                        </td>
                                        <td class="intra_col_15">
                                            {leaves.note ? (
                                                <p>
                                                    <div
                                                        dangerouslySetInnerHTML={{ __html: leaves.note }}
                                                    />
                                                </p>
                                            ) : (
                                                "--"
                                            )}
                                        </td>
                                        <td class="intra_col_10">
                                            {leaves.applied_leave_days ? leaves.applied_leave_days : "--"}
                                        </td>
                                        <td class="intra_col_10">
                                            {leaves.is_advance == 1 ? "--" : leaves.leave_available}
                                        </td>
                                        <td class="intra_col_10">{leaves.status}</td>
                                        <td class="intra_col_10">
                                            {leaves.status == "pending" ? (
                                                <div class="leave_app">
                                                    <span
                                                        class="app"
                                                        onClick={() => this.leave_detail(leaves.id)}
                                                        data-toggle="modal"
                                                        data-target="#approveLeave"
                                                    >
                                                        <i class="fal fa-check-circle"></i>
                                                    </span>
                                                    <span
                                                        class="dec"
                                                        onClick={() => this.leave_detail(leaves.id)}
                                                        data-toggle="modal"
                                                        data-target="#declineLeave"
                                                    >
                                                        <i class="fal fa-times-circle"></i>
                                                    </span>
                                                </div>
                                            ) : leaves.status == "approved" ? (
                                                "Approved"
                                            ) : leaves.status == "declined" ? (
                                                "Declined"
                                            ) : (
                                                ""
                                            )}
                                        </td>
                                        <td class="intra_col_5">
                                            {leaves.status == "pending" ? (
                                                <div class="leave_app">
                                                    <span
                                                        class="delete"
                                                        onClick={() => this.deleteLeaveRequest(leaves.id)}
                                                    >
                                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                                    </span>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {this.state.leaves.map((leaves, key) => (
                            <div class="customer_mob hidden-md">
                                <div class="custmer_list_mob">
                                    <Link
                                        key={key}
                                        to={`/viewLeaveReward/${leaves.employee_id}`}
                                        name={"max"}
                                    >
                                        <div>{leaves.name ? leaves.name : "--"}</div>
                                    </Link>
                                    <div class="wrap">{leaves.date + " - " + leaves.to_date}</div>
                                    <div class="pull-right">
                                        {leaves.status == "pending" ? (
                                            <div class="leave_app">
                                                <span
                                                    class="app"
                                                    onClick={() => this.leave_detail(leaves.id)}
                                                    data-toggle="modal"
                                                    data-target="#approveLeave"
                                                >
                                                    <i class="fal fa-check-circle"></i>
                                                </span>
                                                <span
                                                    class="dec"
                                                    onClick={() => this.leave_detail(leaves.id)}
                                                    data-toggle="modal"
                                                    data-target="#declineLeave"
                                                >
                                                    <i class="fal fa-times-circle"></i>
                                                </span>
                                            </div>
                                        ) : leaves.status == "approved" ? (
                                            "Approved"
                                        ) : leaves.status == "declined" ? (
                                            "Declined"
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                        {this.state.item_count > 0 ? (
                            <div
                                class="d-flex mu-pagination justify-content-between align-items-center"
                                aria-label="Page navigation example"
                            >
                                <div class="txt-dark">
                                    Showing {this.state.offset + 1}~
                                    {this.state.offset + this.state.off_count} of{" "}
                                    {this.state.item_count}
                                </div>
                                <div class="mu-pagination">
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={20}
                                        totalItemsCount={this.state.item_count}
                                        pageRangeDisplayed={5}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        onChange={
                                            this.state.setPage == "yes" ? this.handlePageChange : ""
                                        }
                                    />
                                </div>
                            </div>
                        ) : (
                            <div
                                className="text-center"
                                style={{
                                    color: "#333",
                                    fontSize: "16px",
                                    padding: "70px",
                                    fontWeight: "500",
                                }}
                            >
                                No Data Found
                            </div>
                        )}
                        {/* {this.loadMorecount()} */}
                    </div>
                </div>
            );
        }
    }

    leavesDateRangeSrch(start_date, end_date) {
        this.setState({ from_date: start_date.format("YYYY-MM-DD"), to_date: end_date.format("YYYY-MM-DD"), activePage: 1 }, function () {
            this.leaveList();
        });
    }

    componentDidMount() {
        document.title = "Intranet | Leave Requests";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.leaveList();
        $('.searchTicket.dept').on('click', function () {
            $(this).closest('.intranet_body').find('.filter_dept').slideToggle('slow');
        });
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        if (this.state.hr_permission == 'no') {
            return (
                <Redirect to={'/home'} />
            )
        }
        const handleApply = (event, picker) => {
            picker.element.val(
                picker.startDate.format('DD/MM/YYYY') +
                ' - ' +
                picker.endDate.format('DD/MM/YYYY')
            );
            this.leavesDateRangeSrch(picker.startDate, picker.endDate);
        };
        const handleCancel = (event, picker) => {
            window.location.href = '/leaveRequests';
        };
        const handleCallback = (start, end) => {
            this.leavesDateRangeSrch(start, end);
        };
        return (
            <div>
                <Header brecum_name="Leave Requests" brecum_page="Leave Requests" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <span>Leave Requests</span>
                        </div>
                        <div class="top-row">
                            <div class="left-section leavelop btn-muvi pull-left">
                                <a href="/leaves" class="btn btn-blue mob">
                                    Back
                                </a>
                                <Link to="/leaves" class="btn btn-sky mob">
                                    Leaves
                                </Link>
                                <Link to="/leavesByEmployee" class="btn btn-sky mob">
                                    Leave Balances
                                </Link>
                                <Link to="/leaveLops" class="btn btn-sky mob">
                                    Lops
                                </Link>
                            </div>
                            <div class="right-section leavelop pull-right">
                                <div class="row">
                                    <div class="form-group col-sm-6 col-xs-6 icon-calender">
                                        <div class="filter ">
                                            <DateRangePicker
                                                initialSettings={{
                                                    showDropdowns: true,
                                                    autoUpdateInput: false,
                                                    linkedCalendars: false,
                                                    locale: {
                                                        cancelLabel: 'Clear',
                                                    },
                                                }}
                                                onApply={handleApply}
                                                onCancel={handleCancel}
                                                onCallback={handleCallback}
                                            >
                                                <input type="text" className="form-control" defaultValue="" placeholder="Leave From - Leave To" />
                                            </DateRangePicker>
                                        </div>
                                        <i class="fal fa-calendar-alt"></i>
                                    </div>
                                    <div class="col-md-6 col-xs-12">
                                        <div class="searchTicket emp_dept">
                                            <input type="text" class="form-control" name="search" id="search" placeholder="Search By Name Or Employee Id" onChange={this.searchChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                        </div>
                                        <div class="searchTicket filter dept hidden-md"><i class="fa fa-sliders hidden-md filter"></i></div>
                                    </div>
                                    {/*<div class="col-md-6 col-xs-12 padding_less mob-leave filter_dept">
                                        <div class="form-group col-sm-6 col-xs-6 icon-calender">
                                            <div class="filter right">
                                                <DatePicker
                                                    selected={this.state.fromdate}
                                                    onChange={this.formdateChange}
                                                    placeholderText="Leave From"
                                                    dateFormat="DD/MM/YYYY"
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    readOnly={true}
                                                    
                                                />
                                            </div>
                                            <i class="fal fa-calendar-alt"></i>
                                        </div>
                                        <div class="form-group col-sm-6 col-xs-6 icon-calender">
                                            <div class="filter right">
                                                <DatePicker
                                                    selected={this.state.todate}
                                                    onChange={this.todateChange}
                                                    placeholderText="Leave To"
                                                    dateFormat="DD/MM/YYYY"
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    readOnly={true}
                                                />
                                            </div>
                                            <i class="fal fa-calendar-alt"></i>
                                        </div>
                                    </div>*/}
                                </div>
                            </div>
                            {/* <--modal start for approving Leave-!> */}
                            <div class="modal fade" id="approveLeave" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <h4 style={{ color: "black" }} class="modal-title">Approve Leave</h4>
                                        </div>
                                        <div class="modal-body">
                                            Reasons :
                                            <textarea type="text" name="approve_note" class="form-control" onChange={this.onChange} ></textarea>
                                        </div>

                                        <div class="modal-footer">

                                            <button type="button" name="add_approve" id="add_approve" class="btn btn-sky" onClick={() => this.approve_leave(this.state.leave_detail.id)} >OK</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <--modal end for approving Leave-!> */}

                            {/* <--modal start for declining Leave-!> */}
                            <div class="modal fade" id="declineLeave" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <h4 style={{ color: "black" }} class="modal-title">Decline Leave</h4>
                                        </div>
                                        <div class="modal-body">
                                            Reasons :
                                            <textarea type="text" name="decline_note" class="form-control" onChange={this.onChange} ></textarea>
                                            <span class="error">{this.state.errors["decline_note"]}</span><br></br>
                                        </div>

                                        <div class="modal-footer">

                                            <button type="button" name="add_decline" id="add_decline" class="btn btn-sky" onClick={() => this.decline_leave(this.state.leave_detail.id)}>OK</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <--modal end for declining Leave-!> */}
                        </div>
                        {this.getUserRows()}
                    </div>
                </div>
            </div>
        )
    }
}
export default LeaveRequests;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/leaveRequests.js